import useSWR from 'swr';

export const useInsuredObjectDetails = (fleetId, objectId) =>
        useSWR(fleetId && objectId ? `fleets/${fleetId}/insured-objects/${objectId}` : null);
